import { render, staticRenderFns } from "./PortalContainerVertical.vue?vue&type=template&id=0288e128&"
import script from "./PortalContainerVertical.vue?vue&type=script&lang=js&"
export * from "./PortalContainerVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports